export class Term {
  constructor({
    id = 0,
    termOrder = 0,
    section = '',
    condition = '',
    needsConfirm = false,
    heading = '',
    extraDisplayConditions = null,
    checked = false,
    termItems = [],
  } = {}) {
    this.id = id;
    this.termOrder = termOrder;
    this.section = section;
    this.condition = condition;
    this.needsConfirm = needsConfirm;
    this.heading = heading;
    this.extraDisplayConditions = extraDisplayConditions;
    this.checked = checked;
    this.termItems = termItems;
  }
}

export function CreateTerms(data) {
  return Object.freeze(new Term(data));
}
